import { Badge, BadgeProps, Color, Text } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductPeripheralsState, titleForProductPeripheralState } from 'zens-store'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  unknown: {
    color: Color.metalGrey,
  },
})

interface Props extends Omit<BadgeProps, 'status'> {
  value?: ProductPeripheralsState
}
const Peripherals = (props: Props) => {
  const { value, ...otherProps } = props
  const { t } = useTranslation()
  const title = titleForProductPeripheralState(value, t)

  switch (value) {
    case ProductPeripheralsState.Connected:
      return <Badge title={title} status="success" {...otherProps} />
    case ProductPeripheralsState.SensorDisconnected:
    case ProductPeripheralsState.LedDisconnected:
    case ProductPeripheralsState.SensorAndLedDisconnected:
      return <Badge title={title} status="error" {...otherProps} />
    default:
      return <Text style={styles.unknown}>{title}</Text>
  }
}

export default Peripherals
